/** @format */

import React, { useEffect, useContext } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { roles } from "../../Config/Roles";
import { AuthContext } from "../../Contexts/AuthContext";

const Menu = ({ className }) => {
  const { t: translator } = useTranslation();
  const { master, admin, support, owner } = roles;
  const { roleId, useAccounting,userId } = useContext(AuthContext);
  const { isActiveMenu, toggleMenu } = useContext(GlobalContext);

  var menuItems = document.getElementsByClassName("menu-item");
  var reportsItems = document.getElementsByClassName("reportItems");
  var administrationItems = document.getElementsByClassName(
    "administrationItems",
  );

  for (var i = 0; i < menuItems.length; i++) {
    menuItems[i].onclick = function () {
      if (window.innerWidth < 940) toggleMenu();
      if (
        document.getElementById("pageSubmenu9") &&
        document.getElementById("pageSubmenu9").classList.contains("show")
      ) {
        document.getElementById("administration").click();
      }
      if (
        document.getElementById("submenuInvoicesIssuedReport") &&
        document
          .getElementById("submenuInvoicesIssuedReport")
          .classList.contains("show")
      ) {
        document.getElementById("reports").click();
      }
    };
  }

  for (var i = 0; i < reportsItems.length; i++) {
    reportsItems[i].onclick = function () {
      if (window.innerWidth < 940) toggleMenu();
    };
  }

  for (var i = 0; i < administrationItems.length; i++) {
    administrationItems[i].onclick = function () {
      if (window.innerWidth < 940) toggleMenu();
    };
  }

  const handleAccountingClick = () => {
    handleAdministrationClick();
    handleReportsClick();
    handleVersionClick();
    if (
      document.getElementById("submenuSupport") &&
      document.getElementById("submenuSupport").classList.contains("show")
    ) {
      document.getElementById("supportMenu").click();
    }
  };

  const handleReportsClick = () => {
    if (
      document.getElementById("pageSubmenu9") &&
      document.getElementById("pageSubmenu9").classList.contains("show")
    ) {
      document.getElementById("administration").click();
    }
    if (
      document.getElementById("submenuAccounting") &&
      document.getElementById("submenuAccounting").classList.contains("show")
    ) {
      document.getElementById("accounting").click();
    }
    if (
      document.getElementById("pageSubmenu10") &&
      document.getElementById("pageSubmenu10").classList.contains("show")
    ) {
      document.getElementById("version").click();
    }
    if (
      document.getElementById("submenuSupport") &&
      document.getElementById("submenuSupport").classList.contains("show")
    ) {
      document.getElementById("supportMenu").click();
    }
  };

  const handleAdministrationClick = () => {
    if (
      document.getElementById("submenuInvoicesIssuedReport") &&
      document
        .getElementById("submenuInvoicesIssuedReport")
        .classList.contains("show")
    ) {
      document.getElementById("reports").click();
    }
    if (
      document.getElementById("submenuAccounting") &&
      document.getElementById("submenuAccounting").classList.contains("show")
    ) {
      document.getElementById("accounting").click();
    }
    if (
      document.getElementById("submenuSupport") &&
      document.getElementById("submenuSupport").classList.contains("show")
    ) {
      document.getElementById("supportMenu").click();
    }
  };
  const handleVersionClick = () => {
    if (
      document.getElementById("pageSubmenu9") &&
      document.getElementById("pageSubmenu9").classList.contains("show")
    ) {
      document.getElementById("administration").click();
    }
    if (
      document.getElementById("submenuAccounting") &&
      document.getElementById("submenuAccounting").classList.contains("show")
    ) {
      document.getElementById("accounting").click();
    }
    if (
      document.getElementById("pageSubmenu10") &&
      document.getElementById("pageSubmenu10").classList.contains("show")
    ) {
      document.getElementById("version").click();
    }
    if (
      document.getElementById("submenuSupport") &&
      document.getElementById("submenuSupport").classList.contains("show")
    ) {
      document.getElementById("supportMenu").click();
    }
  };

  const handleSupportClick = () => {
    if (
      document.getElementById("pageSubmenu9") &&
      document.getElementById("pageSubmenu9").classList.contains("show")
    ) {
      document.getElementById("administration").click();
    }
    if (
      document.getElementById("submenuAccounting") &&
      document.getElementById("submenuAccounting").classList.contains("show")
    ) {
      document.getElementById("accounting").click();
    }
    if (
      document.getElementById("pageSubmenu10") &&
      document.getElementById("pageSubmenu10").classList.contains("show")
    ) {
      document.getElementById("version").click();
    }
    if (
      document.getElementById("submenuInvoicesIssuedReport") &&
      document.getElementById("submenuInvoicesIssuedReport").classList.contains("show")
    ) {
      document.getElementById("reports").click();
    }
  };

  useEffect(() => {
    if (window.innerWidth < 940) {
      toggleMenu();
    }
  }, []);

  return (
    <>
      <nav
        id="sidebar"
        className={`${isActiveMenu ? "" : "active"} ${className}`}
      >
        <ul className="list-unstyled components my-first-step">
          <div
            className="text-uppercase"
            style={{
              fontSize: "1.3rem",
              padding: "10px 25px",
              marginBottom: "20px",
            }}
          >
            <span className="menu-hide float-right" onClick={toggleMenu}>
              <span className="icon icon-cancel"></span>
            </span>
          </div>
          {[master, admin, support].includes(Number(roleId)) && (
            <li className="">
              <NavLink className="menu-item" exact to="/">
                <span
                  className="icon icon-home menu-icon"
                  style={{
                    fontWeight: "500",
                    fontSize: 22,
                  }}
                ></span>
                &nbsp; {translator("Main-Sidebar-Home")}
              </NavLink>
            </li>
          )}
          {[owner].includes(Number(roleId)) && (
            <li className="">
              <NavLink className="menu-item" exact to="/dashboard">
                <span
                  className="icon icon-home menu-icon"
                  style={{
                    fontWeight: "500",
                    fontSize: 22,
                  }}
                ></span>
                &nbsp; {translator("Main-Sidebar-Home")}
              </NavLink>
            </li>
          )}
          {[master, admin].includes(Number(roleId)) && (
            <li className="">
              <NavLink className="menu-item" to="/onboarding">
                <span
                  className="icon icon-redirection menu-icon"
                  style={{
                    fontWeight: "500",
                    fontSize: 23,
                  }}
                ></span>
                &nbsp; {translator("Main-Sidebar-Onboarding")}
              </NavLink>
            </li>
          )}
          {window.REACT_APP_VENDOR === "ht"
            ? [master, admin].includes(Number(roleId)) && (
                <li className="">
                  <NavLink className="menu-item" to="/migration">
                    <span
                      className="icon icon-substitution menu-icon"
                      style={{
                        fontWeight: "500",
                        fontSize: 23,
                      }}
                    ></span>
                    &nbsp; {translator("Main-Sidebar-Migration")}
                  </NavLink>
                </li>
              )
            : null}
          {[master, admin, support].includes(Number(roleId)) && (
            <li className="">
              <NavLink className="menu-item" to="/tenants">
                <span
                  className="icon icon-tile-view menu-icon"
                  style={{
                    fontWeight: "500",
                    fontSize: 23,
                  }}
                ></span>
                &nbsp; {translator("Main-Sidebar-Tenants")}
              </NavLink>
            </li>
          )}
          {[master, admin, support, owner].includes(Number(roleId)) && (
            <li className="">
              <NavLink className="menu-item" to="/stores">
                <span
                  className="icon icon-awning-open menu-icon"
                  style={{
                    fontWeight: "500",
                    fontSize: 23,
                  }}
                ></span>
                &nbsp; {translator("Main-Sidebar-Stores")}
              </NavLink>
            </li>
          )}
          <li className="">
            <NavLink className="menu-item" to="/users">
              <span
                className="icon icon-group menu-icon"
                style={{
                  fontWeight: "500",
                  fontSize: 23,
                }}
              ></span>
              &nbsp; {translator("Main-Sidebar-Users")}
            </NavLink>
          </li>
          <li className="">
            <NavLink className="menu-item" to="/pos">
              <span
                className="icon icon-cash-register menu-icon"
                style={{
                  fontWeight: "500",
                  fontSize: 23,
                }}
              ></span>
              &nbsp; {translator("Main-Sidebar-Pos-Devices")}
            </NavLink>
          </li>
          {useAccounting === "true" && (
            <li>
              <a
                href="#submenuAccounting"
                data-toggle="collapse"
                aria-expanded="false"
                className="dropdown-toggle collapsed"
                id="accounting"
                onClick={handleAccountingClick}
              >
                <span
                  className="icon icon-books menu-icon"
                  style={{
                    fontWeight: "500",
                    fontSize: 23,
                  }}
                ></span>
                &nbsp; {translator("Main-Sidebar-Accounting")}
              </a>

              <ul className="collapse list-unstyled" id="submenuAccounting">
                <li style={{ paddingLeft: 30 }}>
                  <NavLink className="reportItems" to="/initial-state">
                    {translator("Main-Sidebar-IntialState")}
                  </NavLink>
                </li>
                <li style={{ paddingLeft: 30 }}>
                  <NavLink className="reportItems" to="/calculation">
                    {translator("Main-Sidebar-Calculation")}
                  </NavLink>
                </li>
                <li style={{ paddingLeft: 30 }}>
                  <NavLink className="reportItems" to="/predisposition">
                    {translator("Main-Sidebar-Predisposition")}
                  </NavLink>
                </li>
                <li style={{ paddingLeft: 30 }}>
                  <NavLink className="reportItems" to="/returnReceipt">
                    {translator("Main-Sidebar-ReturnReceipt")}
                  </NavLink>
                </li>
                <li style={{ paddingLeft: 30 }}>
                  <NavLink className="reportItems" to="/internal-output">
                    {translator("Main-Sidebar-InternalOutput")}
                  </NavLink>
                </li>
                <li style={{ paddingLeft: 30 }}>
                  <NavLink className="reportItems" to="/price-change">
                    {translator("Main-Sidebar-PriceChange")}
                  </NavLink>
                </li>
                <li style={{ paddingLeft: 30 }}>
                  <NavLink className="reportItems" to="/inventory">
                    {translator("Main-Sidebar-Inventory")}
                  </NavLink>
                </li>
                <li style={{ paddingLeft: 30 }}>
                  <NavLink className="reportItems" to="/retail-state">
                    {translator("Main-Sidebar-StateOfRetail")}
                  </NavLink>
                </li>
                <li style={{ paddingLeft: 30 }}>
                  <NavLink className="reportItems" to="/traffic">
                    {translator("Main-Sidebar-Traffic")}
                  </NavLink>
                </li>
                <li style={{ paddingLeft: 30 }}>
                  <NavLink className="reportItems" to="/recapitulation">
                    {translator("Main-Sidebar-Recapitulation")}
                  </NavLink>
                </li>
                <li style={{ paddingLeft: 30 }}>
                  <NavLink className="reportItems" to="/handover">
                    {translator("Predatnica proizvoda")}
                  </NavLink>
                </li>
                <li style={{ paddingLeft: 30 }}>
                  <NavLink className="reportItems" to="/consumption">
                    {translator("Utrošak materijala")}
                  </NavLink>
                </li>
                <li style={{ paddingLeft: 30 }}>
                  <NavLink className="reportItems" to="/store-stock">
                    {translator("Main-Sidebar-StoreStock")}
                  </NavLink>
                </li>
              </ul>
            </li>
          )}
          <li>
            <a
              href="#submenuInvoicesIssuedReport"
              data-toggle="collapse"
              aria-expanded="false"
              className="dropdown-toggle collapsed"
              id="reports"
              onClick={handleReportsClick}
            >
              <span
                className="icon icon-analytics menu-icon"
                style={{
                  fontWeight: "500",
                  fontSize: 23,
                }}
              ></span>
              &nbsp; {translator("Main-Sidebar-Reports")}
            </a>

            <ul
              className="collapse list-unstyled"
              id="submenuInvoicesIssuedReport"
            >
              <li style={{ paddingLeft: 30 }}>
                <NavLink className="reportItems" to="/invoices-issued-report">
                  {translator("Main-Sidebar-InvoicesIssuedReport")}
                </NavLink>
              </li>
              <li style={{ paddingLeft: 30 }}>
                <NavLink className="reportItems" to="/invoices-cash-balance">
                  {translator("Main-Sidebar-InvoicesCashBalance")}
                </NavLink>
              </li>
              <li style={{ paddingLeft: 30 }}>
                <NavLink
                  className="reportItems"
                  to="/invoices-conclusion-report"
                >
                  {translator("Main-Sidebar-InvoicesConclusionCashBalance")}
                </NavLink>
              </li>
              <li style={{ paddingLeft: 30 }}>
                <NavLink className="reportItems" to="/invoices-invoicesTotal">
                  {translator("Main-Sidebar-InvoicesTotal")}
                </NavLink>
              </li>
              <li style={{ paddingLeft: 30 }}>
                <NavLink className="reportItems" to="/invoices-invoiceslist">
                  {translator("Main-Sidebar-InvoicesList")}
                </NavLink>
              </li>
              <li style={{ paddingLeft: 30 }}>
                <NavLink
                  className="reportItems"
                  to="/invoices-invoicesPaymentMethod"
                >
                  {translator("Main-Sidebar-InvoicesPaymentMethod")}
                </NavLink>
              </li>
              <li style={{ paddingLeft: 30 }}>
                <NavLink
                  className="reportItems"
                  to="/invoices-invoicesUnfiscalizedAccounts"
                >
                  {translator("Main-Sidebar-InvoicesUnfiscalizedAccounts")}
                </NavLink>
              </li>
              <li style={{ paddingLeft: 30 }}>
                <NavLink className="reportItems" to="/tips-issued-report">
                  {translator("Main-Sidebar-TipReports")}
                </NavLink>
              </li>
            </ul>
          </li>
          <li>
            <a
              href="#pageSubmenu9"
              data-toggle="collapse"
              aria-expanded="false"
              className="dropdown-toggle collapsed"
              id="administration"
              onClick={handleAdministrationClick}
            >
              <span
                className="icon icon-tools menu-icon"
                style={{
                  fontWeight: "500",
                  fontSize: 23,
                }}
              ></span>
              &nbsp; {translator("Main-Sidebar-Administration")}
            </a>
            <ul className="collapse list-unstyled" id="pageSubmenu9">
              {[master, admin, support].includes(Number(roleId)) && (
                <li style={{ paddingLeft: 30 }}>
                  <NavLink className="administrationItems" to="/language">
                    {translator("Main-Sidebar-Languages")}
                  </NavLink>
                </li>
              )}
              <li style={{ paddingLeft: 30 }}>
                <NavLink className="administrationItems" to="/tax-rates">
                  {translator("Menu-Administration-TaxRates")}
                </NavLink>
              </li>
              <li style={{ paddingLeft: 30 }}>
                <NavLink className="administrationItems" to="/pay-methods">
                  {translator("Menu-Administration-PayOption")}
                </NavLink>
              </li>
              <li style={{ paddingLeft: 30 }}>
                <NavLink className="administrationItems" to="/unit-of-measures">
                  {translator("Menu-Administration-UnitOfMeasure")}
                </NavLink>
              </li>
              {[master, admin, support].includes(Number(roleId)) && (
                <li style={{ paddingLeft: 30 }}>
                  <NavLink className="administrationItems" to="/messages">
                    {translator("Menu-Administration-Messages")}
                  </NavLink>
                </li>
              )}

              <li style={{ paddingLeft: 30 }}>
                <NavLink className="administrationItems" to="/card-types">
                  {translator("Menu-Administration-CardTypes")}
                </NavLink>
              </li>
              <li style={{ paddingLeft: 30 }}>
                <NavLink className="administrationItems" to="/instructions">
                  {translator("Menu-Administration-Instructions")}
                </NavLink>
              </li>
              <li style={{ paddingLeft: 30 }}>
                <NavLink
                  className="administrationItems"
                  to="/video-instructions"
                >
                  {translator(
                    "Menu-Administration-VideoInstructions",
                    "Video upute"
                  )}
                </NavLink>
              </li>
               {[master, admin, support].includes(Number(roleId)) && (
                 <li style={{ paddingLeft: 30 }}>
                <NavLink className="administrationItems" to="/surveys">
                  {translator("Menu-Administration-Surveys")}
                </NavLink>
              </li>
              )}
                {[master].includes(Number(roleId)) && (
                 <li style={{ paddingLeft: 30 }}>
                <NavLink className="administrationItems" to="/digital-content">
                  {translator("Menu-Administration-DigitalContent")}
                </NavLink>
              </li>
              )}
             
             
            </ul>
          </li>
          {[master, admin].includes(Number(roleId)) && (
            <li className="">
              <NavLink className="menu-item" to="/knowledge-base">
                <span
                  className="icon icon-attachment menu-icon"
                  style={{
                    fontWeight: "500",
                    fontSize: 23,
                  }}
                ></span>
                &nbsp; {translator("Menu-Knowledge-Base")}
              </NavLink>
            </li>
          )}
          {[master, admin, support].includes(Number(roleId)) && (
            <li>
              <a
                href="#submenuSupport"
                data-toggle="collapse"
                aria-expanded="false"
                className="dropdown-toggle collapsed"
                id="supportMenu"
                onClick={handleSupportClick}
              >
                <span
                  className="icon icon-help menu-icon"
                  style={{
                    fontWeight: "500",
                    fontSize: 23,
                  }}
                ></span>
                &nbsp; {translator("Menu-Support")}
              </a>
              <ul className="collapse list-unstyled" id="submenuSupport">
                <li style={{ paddingLeft: 30 }}>
                  <NavLink className="administrationItems" to="/support">
                    {translator("Menu-Support-Overview")}
                  </NavLink>
                </li>
                <li style={{ paddingLeft: 30 }}>
                  <NavLink className="administrationItems" to="/support-statistics">
                    {translator("Menu-Support-Statistics")}
                  </NavLink>
                </li>
              </ul>
            </li>
          )}
          {[master].includes(Number(roleId)) && (
            <li>
              <a
                href="#pageSubmenu10"
                data-toggle="collapse"
                aria-expanded="false"
                className="dropdown-toggle collapsed"
                id="version"
                onClick={handleVersionClick}
              >
                <span
                  className="icon icon-sub-settings menu-icon"
                  style={{
                    fontWeight: "500",
                    fontSize: 23,
                  }}
                ></span>
                &nbsp; {translator("Main-Sidebar-Version")}
              </a>
              <ul className="collapse list-unstyled" id="pageSubmenu10">
                {[master, admin, support].includes(Number(roleId)) && (
                  <li style={{ paddingLeft: 30 }}>
                    <NavLink className="administrationItems" to="/pos-versions">
                      {translator("Menu-Sidebar-PosVersion")}
                    </NavLink>
                  </li>
                )}
                {[master, admin, support].includes(Number(roleId)) && (
                  <li style={{ paddingLeft: 30 }}>
                    <NavLink
                      className="administrationItems"
                      to="/version-managing"
                    >
                      {translator("Menu-Sidebar-VersionManaging")}
                    </NavLink>
                  </li>
                )}
                {[master, admin, support].includes(Number(roleId)) && (
                  <li style={{ paddingLeft: 30 }}>
                    <NavLink
                      className="administrationItems"
                      to="/version-reporting"
                    >
                      {translator("Menu-Sidebar-VersionReporting")}
                    </NavLink>
                  </li>
                )}
              </ul>
            </li>
          )}
        </ul>
      </nav>
    </>
  );
};

export default Menu;
